import { useNavigate } from 'react-router-dom';
import { IoChevronForward } from 'react-icons/io5';
import './Breadcrumb.css';

/**
 * items: [{ label, to }] — final item has no `to` and renders as plain text.
 */
const Breadcrumb = ({ items }) => {
  const navigate = useNavigate();

  return (
    <nav className="breadcrumb">
      {items.map((item, i) => {
        const isLast = i === items.length - 1;
        return (
          <span key={i} className="breadcrumb-item">
            {item.to && !isLast ? (
              <button className="breadcrumb-link" onClick={() => navigate(item.to)}>
                {item.label}
              </button>
            ) : (
              <span className="breadcrumb-current">{item.label}</span>
            )}
            {!isLast && (
              <span className="breadcrumb-sep">
                <IoChevronForward />
              </span>
            )}
          </span>
        );
      })}
    </nav>
  );
};

export default Breadcrumb;
